import { Avatar, ErrorBoundary, Icon, Skeleton } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { useRepository } from "../../app/services/repository"

export function RepositoryAvatar() {
  return (
    <ErrorBoundary renderError={() => <AvatarError />}>
      <Suspense fallback={<AvatarLoading />}>
        <RepositoryAvatarContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function RepositoryAvatarContent() {
  const { uploadedAvatar } = useRepository()

  return (
    <Avatar
      size={40}
      variant="square"
      imageUrl={getOptimizedImageURL(uploadedAvatar)}
      hasBorder={false}
      fallback={<PrismicIcon />}
    />
  )
}

function AvatarLoading() {
  return <Skeleton height={40} width={40} />
}

function AvatarError() {
  return (
    <Avatar
      size={40}
      variant="square"
      hasBorder={false}
      fallback={<PrismicIcon />}
    />
  )
}

function PrismicIcon() {
  return <Icon name="prismic" color="grey12" size="large" />
}

export function getOptimizedImageURL(fromUrl?: string) {
  if (!fromUrl) return fromUrl

  const url = new URL(fromUrl)

  url.searchParams.set("w", "80")
  url.searchParams.set("h", "80")
  url.searchParams.set("fit", "crop")

  return url.toString()
}
